module.exports = __webpack_public_path__ + "static/media/20ECE22.257923b1.jpg";